import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

/**
 * The two views sit side by side as topbar tabs, so switching between the customer and the pentester
 * is one click. The pentester detail page is a hidden child of its queue.
 */
export const findingVerificationFlowNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.app_finding_verification_flow, {
      displayName: 'Finding verification',
      icon: SolIcon.finding,
      showChildrenAsTabs: true,
      children: [
        // Each view owns a hidden detail child pointing at the same page, so the breadcrumb reads
        // correctly whichever view you double-clicked from.
        SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_customer, {
          displayName: 'Customer view',
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_customer_detail, {
              displayName: 'Finding details',
            }),
          ],
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_pentester, {
          displayName: 'Pentester view',
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_pentester_detail, {
              displayName: 'Finding details',
            }),
          ],
        }),
      ],
    }),
    // The pentester's second section, sitting under Finding verification in the sidebar. Its three
    // tabs mirror the platform's own engagements/overview | list | accounts.
    SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_engagements, {
      displayName: 'Engagements',
      icon: SolIcon.document,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_engagements_overview, {
          displayName: 'Overview',
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_engagements_list, {
          displayName: 'Engagements',
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_engagement_detail, {
              displayName: 'Engagement details',
            }),
          ],
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_verification_flow_engagements_accounts, {
          displayName: 'Accounts',
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
